module.exports = __webpack_public_path__ + "arrow-down.svg?3e64a47afcc06554e68e8c6590f0b5cf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-down.svg
// module id = 84
// module chunks = 0